import { ECode } from "~/_enums/ECode";
import { TDaoApiConfig } from "~/_libs/fetch/fetchConfig";
import { fetchGetJson } from "~/_libs/fetch/fetchGetJson";
import * as Sentry from "@sentry/react";
import { ERROR_UNKNOWN } from "~/_constants/errors";
import { TUserAccounts } from "~/_types/TUserAccount";

type TGetUserAccountsRequestParams = {
  userId: string;
};
type TGetUserAccountsRequestQuery = {
  /** @default null */
  emailAccount?: "true" | "false" | null;
};
type TParams = TGetUserAccountsRequestParams & TGetUserAccountsRequestQuery;

type TGetUserAccountsOutputDto = {
  code: typeof ECode.Success;
  data: TUserAccounts;
};

export const getUserAccounts = (
  { userId, emailAccount }: TParams,
  config: TDaoApiConfig,
) => {
  const searchParams = new URLSearchParams();
  emailAccount && searchParams.append("emailAccount", emailAccount);
  const query = searchParams.toString();

  return fetchGetJson<TGetUserAccountsOutputDto>(
    `/users/${userId}/accounts`,
    { query: query ? `?${query}` : query },
    config,
  ).then((result) => {
    switch (result.code) {
      case "000":
        return result;
      default:
        Sentry.captureException(ERROR_UNKNOWN, {
          extra: {
            apiName: "getUserAccounts",
            payload: { query },
            res: result,
          },
        });

        throw new Error(ERROR_UNKNOWN);
    }
  });
};
